import styled from 'styled-components'

export const Title = styled.h6.attrs({
  className: 'tds-headline-06'
})`
  margin-bottom: 0;
  margin-top: 16px;
`
